import standardEvents from './eventDictionaryStandard'
import eventPayload from './eventPayload'
import storeEvent from './storeEvent'

const CONSOLE_LOG_EVENT_NAME = false
const CONSOLE_LOG_EVENT_PROPS = false

export default function (eventName, options, cb) {
  let amplitudeEventName = standardEvents[eventName]
  let payload = eventPayload(options)

  storeEvent(amplitudeEventName, payload, cb)
  printEvent(amplitudeEventName, payload)
}

const printEvent = (amplitudeEventName, payload) => {
  if (CONSOLE_LOG_EVENT_NAME)  {
    console.log('EVT --> ', amplitudeEventName)
  }

  if (CONSOLE_LOG_EVENT_PROPS) {
    for (let key in payload) {
      console.log(`prop --> ${key} => ${String(payload[key]).substr(0, 50)}`)
    }
  }
}



// WEBPACK FOOTER //
// ./client/events/dispatch.js